/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportEnergyDaily { 
    date?: string;
    production?: number;
    standby?: number;
    cip?: number;
    standstill?: number;
}

